<template>
    <select>
        <option v-for="option in options" :value="option.id" :key="option.id">{{ option.name }}</option>
    </select>
</template>
<script>


export default {
    components : {

    },
    props: {
        value: {
            default: ""
        },
        options: {
            type: Array,
            default: []
        },
        placeholder: {
            type: String,
            default: ""
        },
        defaultText: {
            type: String,
            default: "Please select..."
        },
        hideSearchBox: {
            type: Boolean,
            default: false
        },
        allowClear : {
            type: Boolean,
            default: true
        }
    }
    ,
    mounted(){
        this.initialize();
    },
    watch: {
        selectedValue (newValue, oldValue) {
            if (this.initialized) {
                this.$emit('input', newValue)
            }
        },
        options ( newValue, oldValue ){
            //this.selectedValue = []
            //if (newValue != this.selectedValue)
                //$(this.$el).val(newValue).trigger("change")
            if (this.initialized) {
                setTimeout(() => {
                    this.initialize();
                });
            }
        },
        value (newValue, old) {
            this.selectedValue = newValue;
            $(this.$el).val(newValue).trigger("change")
        },
    },
    destroyed: function () {
        $(this.$el).off().select2('destroy')
    },
    data () {
        return {
            selectedValue : "",
            initialized: false
        }
    },
    computed: {

    },
    methods : {
        initialize(){
            this.selectedValue = this.value
            var vm = this;
            $(this.$el)
                // init select2
                .select2({
                    placeholder: vm.defaultText,
                    minimumInputLength: 0,
                    minimumResultsForSearch: vm.hideSearchBox ? Infinity : 5,
                    allowClear: vm.allowClear,
                })
                .val(vm.selectedValue)
                .trigger('change')
                // emit event on change.
                .on('change', function () {
                    vm.selectedValue = $(this).val()
                });

            setTimeout(() => {
                this.initialized = true;
            })
        },
        removeSel2(){
            $(this.$el).select2('destroy')
        },
    }
}
</script>